import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    header: {
        id: '_.dashboard.page_not_found_view.header',
        defaultMessage: '404 Error'
    },
    description: {
        id: '_.dashboard.page_not_found_view.description',
        defaultMessage: `Sorry, we couldn't find that page. You might want to try going back to {homeLink} and continue browsing from there.`
    },
    descriptionLink: {
        id: '_.dashboard.page_not_found_view.description_link',
        defaultMessage: 'iwoca.co.uk'
    }
});
